(function($, undefined) {
	"use strict";
	
	let utils;

	const LOCATION_SIDE_MENU_KEY = "locationSideMenuCollapse";

	const SIDE_MENU_COLLAPSE_CLASS = "side-menu_collapsed";
	const SIDE_MENU_TOGGLE_CLASS = "side-menu_toggled";

	function init() {
		utils = Fw.component.models().utils;

		$('.side-menu__collapse, .side-menu-mobile').on('click', onClickActivateMenu);
		$('.side-menu__item ').on('click', onSideMenuItemClick);
	}

	function onClickActivateMenu({ currentTarget }) {
		const sideMenu = currentTarget.parentNode;
		const classToActivate = currentTarget.dataset.type === "collapse" ? SIDE_MENU_COLLAPSE_CLASS : SIDE_MENU_TOGGLE_CLASS;
		const menuIsActive = sideMenu.classList.contains(classToActivate)

		if (classToActivate === SIDE_MENU_COLLAPSE_CLASS) {
			utils.saveSessionVariable(LOCATION_SIDE_MENU_KEY, !menuIsActive);
		}

		if (menuIsActive) {
			sideMenu.classList.remove(classToActivate);
		} else {
			sideMenu.classList.add(classToActivate);
		}
	}

	function onSideMenuItemClick(e) {
		if (e.currentTarget.classList.contains('side-menu__item_disabled')) {
			e.preventDefault();
		}
	}
	
	$(init);
	
})(jQuery);